import { skills } from "../../config"; 

// Skills 
const Skill = () => {

  return (
      <div name='skills' className='px-4 pt-12 pb-40 text-center'>
        <div className='p-7 text-2xl font-semibold'>
          Skills
        </div>
        <div className='my-5 grid lg:grid-cols-3 gap-8 justify-items-center grid-cols-2 '>
            {skills.map((item , index) => {
              return (
                <div key={index}>
                <img 
                  src={item.path}
                  alt={item.name}
                  className="m-2 w-20"
                />
                <span>{item.name}</span>
                </div>
              )
            })}
        </div>
      </div>
  );
}

export default Skill;
